import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { AppCenterAnalytics } from '@ionic-native/app-center-analytics/ngx';
// import { directories } from '../boot/meteor/index.js'
// import codePush from 'code-push'
import { mapState } from 'vuex';
var deferredPrompt; // import Uzer from 'classes/Uzer'

import VuePageTransition from 'components/VuePageTransition';
export default {
  components: {
    'my-header': require('components/Header').default,
    VuePageTransition: VuePageTransition
  },
  data: function data() {
    return {
      showNoConnectionDialog: false,
      showAppInstallBanner: false,
      // left: false,
      // right: true,
      status: undefined // medals: ['medal----------1', 'medal----------2', 'medal----------3']
      // medals: ['medal----------1']

    };
  },
  computed: _objectSpread({}, mapState(['medals'])),
  created: function created() {
    var _this = this;

    this.$meteor.tracker.autorun(function () {
      // this.connected = this.$meteor.status().connected
      _this.status = _this.$meteor.status().status;
    });
    /*
            const users = {
                data: {
                    1: {
                        id: 1,
                        name: 'Michael',
                        email: 'michael@example.com'
                    }
                }
            }
    */
    // console.log('INSERTTTTTTTTTTTTTTTTT')
    // Uzer.insert({ data: {
    //         id: 1,
    //         name: 'Michael',
    //         email: 'michael@example.com'
    //     }
    // })
    // this.$root.$on('new_medals', function (payLoad) {
    //   this.showMedals(payLoad)
    // })
    // console.log(directories)
    // this.$meteor.tracker.autorun(() => {
    //     // this.loginStatus()
    //     let result = directories.find({}, { sort: { createdAt: -1 } })
    //         .map((item) => {
    //             return item.emails[0].address
    //         })
    //     // .map((item) => {
    //     //     console.log(item)
    //     //     return {
    //     //         _id: item._id,
    //     //          _email: item.emails[0].address,
    //     //          _editing: false
    //     //     }
    //     // })
    //     // console.log(result[0])
    //     // this.userData = result[0] !== undefined ? result[0] : 'No user'
    //     this.userData = result[0] !== undefined ? '' : 'No user'
    // })
  },
  mounted: function mounted() {
    var _this2 = this;

    var neverShowAppInstallBanner = this.$q.localStorage.getItem('neverShowAppInstallBanner');

    if (!neverShowAppInstallBanner) {
      window.addEventListener('beforeinstallprompt', function (e) {
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault(); // Stash the event so it can be triggered later.

        deferredPrompt = e; // Update UI notify the user they can install the PWA

        setTimeout(function () {
          _this2.showAppInstallBanner = true;
        }, 3000);
      });
    } // var Sentry = cordova.require('sentry-cordova.Sentry')
    // Sentry.init({ dsn: 'https://da6fd50eeb1441aba1e1dc26c3bb549f@sentry.io/1505001' })

  },
  beforeCreate: function beforeCreate() {// var success = function () {
    //     console.log(' MS App Center Event tracked MVD')
    // }
    //
    // var error = function (error) {
    //     console.error(error)
    // }
    // window.AppCenter.Analytics.trackEvent('Video clicked MVD', { Category: 'Music', FileName: 'favorite.avi' }, success, error)

    /* this.$store.dispatch('initConnectedStateTracker')
    this.$store.dispatch('initLoginStateTracker')
    this.$store.dispatch('initMeasuresTracker')
    this.$store.dispatch('initNoticesTracker')
    this.$store.dispatch('initAdvertsTracker')
    this.$store.dispatch('initGebiedTracker') */
    // this.$store.dispatch('content/loadContent')
  },
  methods: {
    getAvatarUrl: function getAvatarUrl() {
      return "statics/".concat(this.$store.state.user.profile.type, ".png");
    },
    installApp: function installApp() {
      var _this3 = this;

      // Hide the app provided install promotion
      this.showAppInstallBanner = false; // Show the install prompt

      deferredPrompt.prompt(); // Wait for the user to respond to the prompt

      deferredPrompt.userChoice.then(function (choiceResult) {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');

          _this3.neverShowAppInstallBanner();
        } else {
          console.log('User dismissed the install prompt');
        }
      });
    },
    neverShowAppInstallBanner: function neverShowAppInstallBanner() {
      this.showAppInstallBanner = false;
      this.$q.localStorage.set('neverShowAppInstallBanner', true);
    }
  },
  watch: {
    connected: function connected(val) {// this.showNoConnectionDialog = !val
    }
  }
};